import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiServerService } from 'src/app/core/services/api/api-server.service';
import { AsignacionesService } from 'src/app/core/services/asignaciones/asignaciones.service';
import { UsuarioService } from 'src/app/core/services/usuario/usuario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-asignar',
  templateUrl: './asignar.component.html',
  styleUrls: ['./asignar.component.scss']
})
export class AsignarComponent implements OnInit {
  itemsSelecteds: any
  users: any = []
  userSelected = null
  asigned = false;
  esEjecutor = this.usuarioServices.getRoles().includes("EJECUTOR")

  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;
  @ViewChild('userInput') userInput: ElementRef<HTMLInputElement>; // 👈 lo usaremos para dar focus

  openAutocomplete() {
    this.userInput?.nativeElement?.focus();
    if (this.autocompleteTrigger && !this.autocompleteTrigger.panelOpen) {
      this.autocompleteTrigger.openPanel();
      this.filteredUsers = this.users;
    }
  }
  constructor(
    private usuarioServices: UsuarioService,
    private dialogRef: MatDialogRef<AsignarComponent>, // Añadir esta línea

    private asignacionService: AsignacionesService, private snackBar: MatSnackBar, @Inject(MAT_DIALOG_DATA) public data: { itemsSelecteds: string }, private service: ApiServerService) {
    this.itemsSelecteds = data.itemsSelecteds;

    this.asignacionService.users(this.usuarioServices.getSections()).subscribe(res => {
      this.users = []
      res.data.forEach(d => {
        let name = d.username;
        if (d.name) name = name + " (" + d.name + "," + d.lastname + ")"
        this.users.push(d.username)
      })
    })

  }

  ngOnInit(): void {
    this.filteredUsers = this.users;

    if (this.esEjecutor) {
      this.userSelected = this.usuarioServices.getUsername();
    } else {
      this.userCtrl.valueChanges.pipe(
        startWith(''),
        map(value => {
          // Resetear userSelected si no es una opción válida
          if (!this.users.includes(value)) {
            this.userSelected = null;
          } else {
            this.userSelected = value;
          }

          return this._filter(value || '');
        })
      ).subscribe(filtered => {
        this.filteredUsers = filtered;
      });
    }


  }
  asignar() {
    if (this.userSelected != null) {
      let ids: any[] = []
      this.itemsSelecteds.forEach(d => {
        ids.push(d._id)
      })
      this.asignacionService.asignar(ids, this.userSelected, [])
        .subscribe(
          res => {

            // Cargar de nuevo las listas
            this.snackBar.open('Las asignaciones se guardaron correctamente', 'x', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
              panelClass: ['green-snackbar'],
            });
            this.dialogRef.close(); // Cerrar el modal después de la asignación exitosa

          },
          (err: HttpErrorResponse) => {
            console.log('err:', err);
            let errorMessage = 'No se pudo asignar';

            if (typeof err === 'string') {
              errorMessage = `Error: ${err}`;
            }

            this.snackBar.open(errorMessage, 'x', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center',
              panelClass: ['red-snackbar'],
            });
          }
        );
    } else {
      this.snackBar.open('Debe seleccionar una categoría', 'x', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center',
        panelClass: ['yellow-snackbar'],
      });
    }
  }
  userCtrl = new FormControl();
  filteredUsers: string[];



  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.users.filter(user => user.toLowerCase().includes(filterValue));
  }

}
